import { useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../utils/contexts/UserContext";
import { visibleAdminItems } from "../../components/navigation/navItems";

// Management hub: cards for every administration destination the user can reach
// (Users, Schedule Import, Templates, Materials). Keeps these tools one tap from
// the sidebar's single "Administration" item instead of crowding the rail.
export default function AdminHub() {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);

  const items = visibleAdminItems(user);

  // Deep-link guard: nothing to manage → back to the dashboard.
  if (items.length === 0) return <Navigate to="/" replace />;

  return (
    <div className="p-6 bg-slate-50 min-h-full">
      <div className="max-w-4xl mx-auto">
        {/* No in-page <h1>: the BaseLayout header bar already shows the page
            title ("Administration"). Just a lead-in description here. */}
        <p className="mb-8 text-sm text-slate-500">{t("admin.subtitle")}</p>

        <div className="grid gap-4 sm:grid-cols-2">
          {items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-indigo-300 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 transition group-hover:bg-indigo-100">
                {item.icon}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-bold text-slate-800">
                  {t(item.labelKey)}
                </p>
                {item.descKey && (
                  <p className="mt-0.5 text-xs text-slate-500 leading-relaxed">
                    {t(item.descKey)}
                  </p>
                )}
              </div>
              <svg
                className="ml-auto mt-1 h-4 w-4 shrink-0 text-slate-300 transition group-hover:text-indigo-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2.2"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
